import { createTestIds } from '../../utils';

export const getSummaryItemTestIds = createTestIds('summary-item', [
  'primary',
  'secondary',
  'visual',
  'actions'
] as const);
